import PropTypes from 'prop-types';
import React from 'react';

import Meta from '../Meta';
import Footer from '../Footer';

import './styles.css';

/**
 * Page wrapper, including meta and footer
 */
const Page = ({ children }) => (
  <div>
    <Meta />
    {children}
    <Footer />
  </div>
);

Page.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

Page.defaultProps = {
  children: [],
};

export default Page;
